// extracted by mini-css-extract-plugin
module.exports = {"container":"Cards_container__2cpn5","card":"Cards_card__3OMRd","leftSection":"Cards_leftSection__1p8eD","rightSection":"Cards_rightSection__3WcNj"};